import { useMutationWithToaster } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

import { createResolverFactory } from "../../TaskForm/hooks";

function createMutationFactory() {
  const query = `
  mutation createConditionsGroup($conditions: [ConditionInput]!, $taskId: ID, $nextWorkflowId: ID) {
    createConditionsGroup(conditions: $conditions, taskId: $taskId, nextWorkflowId: $nextWorkflowId) {
      conditionsGroup {
        id
      }
    }
  }
  `;

  const resolver = ({ data }) => {
    return data;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

function deleteMutationFactory() {
  const query = `
  mutation deleteConditionsGroup($id: ID!) {
    deleteConditionsGroup(conditionsGroupId: $id) {
      success
    }
  }
  `;

  const resolver = ({ data: { success } }) => {
    return success;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

function updateMutationFactory() {
  const query = `
  mutation updateConditionsGroup($workflowId: ID!, $conditions: [ConditionInput]!, $conditionsGroupId: ID!) {
    updateConditionsGroup(workflowId: $workflowId, conditions: $conditions, conditionsGroupId: $conditionsGroupId) {
      conditionsGroup {
        id
      }
    }
  }
  `;

  const resolver = ({ data }) => {
    return data;
  };

  return { query: query, resolver: createResolverFactory(resolver) };
}

export function useConditionModalActions(onDone) {
  const [createConditionsGroup, { loading: isCreating }] =
    useMutationWithToaster(createMutationFactory, { onDone });

  const [deleteConditionsGroup, { loading: isDeleting }] =
    useMutationWithToaster(deleteMutationFactory, { onDone });

  const [updateConditionsGroup, { loading: isUpdating }] =
    useMutationWithToaster(updateMutationFactory, { onDone });

  return {
    isLoading: isCreating || isDeleting || isUpdating,
    create: (_, id, data, itemType) => {
      return createConditionsGroup(
        {
          ...(itemType === "task" ? { taskId: id } : { nextWorkflowId: id }),
          ...data,
        },
        {
          successMsg: "Condition created successfully",
          defaultErrorMsg: "Failed to create condition",
        }
      );
    },
    update: (workflowId, _, data) => {
      return updateConditionsGroup(
        {
          workflowId: toGlobalId("Workflow", workflowId),
          ...data,
        },
        {
          successMsg: "Condition updated successfully",
          defaultErrorMsg: "Failed to update condition",
        }
      );
    },
    remove: (id) => {
      return deleteConditionsGroup(
        { id },
        {
          successMsg: "Condition deleted successfully",
          defaultErrorMsg: "Failed to delete condition",
        }
      );
    },
  };
}

export default useConditionModalActions;
